module.exports = __webpack_public_path__ + "img/ring_g_0_0_1@2x.0cfb2ea1.png";